"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_ADT = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F2F9F6" },
          100: { value: "#CBE6DA" },
          200: { value: "#9DD1BA" },
          300: { value: "#65B592" },
          400: { value: "#42A57A" },
          500: { value: "#138F58" },
          600: { value: "#007944" },
          700: { value: "#006237" },
          800: { value: "#00532E" },
          900: { value: "#003C22" },
        },
        secondary: {
          50: { value: "#F8F9E2" },
          100: { value: "#E3E687" },
          200: { value: "#C7CD22" },
          300: { value: "#A7AC1D" },
          400: { value: "#969A1A" },
          500: { value: "#7E8216" },
          600: { value: "#6A6E12" },
          700: { value: "#55580F" },
          800: { value: "#484A0C" },
          900: { value: "#343609" },
        },
      },
    },
  },
});
